namespace Portico.Services {

	import pme = Portico.Models.Enterprise;
	import psga = apigateway.client;
	import psgm = apigateway.models;
    import Inject = Portico.Decorators.Inject;
    import Service = Portico.Decorators.Service;

    export interface IPharmacyService {
		get(pharmacyId: number): angular.IPromise<pme.Pharmacy>;
		populate(account: pme.Account): angular.IPromise<boolean>;
		save(pharmacy: pme.Pharmacy): angular.IPromise<pme.Pharmacy>;
		search(pharmacy: pme.Pharmacy): angular.IPromise<pme.Pharmacy[]>;
    }

    @Service('app', 'pharmacyService')
	@Inject('$q', 'PharmacyV2Api')
    export class PharmacyService implements IPharmacyService {
        constructor(
            private $q: angular.IQService,
			private pharmacyV2Api: psga.PharmacyV2Api
        ) { }

		get(pharmacyId: number): angular.IPromise<pme.Pharmacy> {
			// TODO: wrap in an edge call
			return this.$q.when(this.pharmacyV2Api.pharmacyGetByTenantId(pharmacyId).then((response) => {
				return new pme.Pharmacy(response.data.data);
			}));
		}

		populate(account: pme.Account): angular.IPromise<boolean> {
			const promises: angular.IPromise<void>[] = [];

			for (const relationship of account.pharmacyRelationships) {
				if (!relationship.pharmacy) {
					const promise = this.get(relationship.pharmacyId).then((pharmacy) => {
						relationship.pharmacy = pharmacy;
					});

					promises.push(promise);
				}
			}

			return this.$q.all(promises).then(() => {
				return true;
			});
		}

		save(pharmacy: pme.Pharmacy): angular.IPromise<pme.Pharmacy> {
			const request: DeepPartial<psgm.PharmacyUpsearchModel> = {
				pharmacyId: _.toNumber(pharmacy.id),
				pharmacyName: _.get(pharmacy, 'name', ''),
				nabp: _.get(pharmacy, 'nabp', ''),
				npi: _.get(pharmacy, 'npi', ''),
				pharmacyType: _.toNumber(pharmacy.type),
				pharmacySpecialization: _.toNumber(pharmacy.specialization),
				addresses: _.map(pharmacy.addresses, (v) => {
					return {
						addressId: v.id,
						addressType: _.toNumber(v.type),
						addressOne: _.get(v, 'address1', ''),
						addressTwo: _.get(v, 'address2', ''),
						city: _.get(v, 'city', ''),
						state: _.get(v, 'state', ''),
						zip: _.get(v, 'zip', ''),
						country: _.get(v, 'country', '')
					};
				}),
				contacts: _.map(pharmacy.contacts, (v) => {
					return {
						contactId: v.id,
						contactType: _.toNumber(v.type),
						firstName: _.get(v, 'firstName', ''),
						lastName: _.get(v, 'lastName', ''),
						occupationDescription: _.get(v, 'occupationDescription', ''),
						addresses: _.map(v.addresses, (u) => {
							return {
								addressId: u.id,
								addressType: _.toNumber(u.type),
								addressOne: _.get(u, 'address1', ''),
								addressTwo: _.get(u, 'address2', ''),
								city: _.get(u, 'city', ''),
								state: _.get(u, 'state', ''),
								zip: _.get(u, 'zip', ''),
								country: _.get(u, 'country', '')
							};
						}),
						emailAddresses: _.map(v.emailAddresses, (u) => {
							return {
								emailAddressId: u.id,
								emailAddressType: _.toNumber(u.type),
								address: _.get(v, 'address', ''),
								language: _.get(v, 'language', '')
							};
						}),
						phoneNumbers: _.map(v.phoneNumbers, (u) => {
							return {
								phoneId: u.id,
								phoneType: _.toNumber(u.type),
								phonePurpose: _.toNumber(u.purpose),
								phoneNumber: _.get(v, 'number', ''),
								extension: _.get(v, 'extension', ''),
								contactDatePreferenceType: _.toNumber(u.contactDatePreferenceType),
								bestDaysToCall: _.get(v, 'bestDaysToCall', ''),
								contactTimePreferenceType: _.toNumber(u.contactTimePreferenceType),
								bestTimeToCall: _.get(v, 'bestTimeToCall', ''),
								language: _.get(v, 'language', ''),
								timeZone: _.get(v, 'timeZone', '')
							};
						}),
						webAddresses: _.map(v.webAddresses, (u) => {
							return {
								webAddressId: u.id,
								webAddressType: _.toNumber(u.type),
								url: _.get(v, 'url', '')
							};
						})
					};
				}),
				phoneNumbers: _.map(pharmacy.phoneNumbers, (v) => {
					return {
						phoneId: v.id,
						phoneType: _.toNumber(v.type),
						phonePurpose: _.toNumber(v.purpose),
						phoneNumber: _.get(v, 'number', ''),
						extension: _.get(v, 'extension', ''),
						contactDatePreferenceType: _.toNumber(v.contactDatePreferenceType),
						bestDaysToCall: _.get(v, 'bestDaysToCall', ''),
						contactTimePreferenceType: _.toNumber(v.contactTimePreferenceType),
						bestTimeToCall: _.get(v, 'bestTimeToCall', ''),
						language: _.get(v, 'language', ''),
						timeZone: _.get(v, 'timeZone', '')
					};
				}),
				emailAddresses: _.map(pharmacy.emailAddresses, (v) => {
					return {
						emailAddressId: v.id,
						emailAddressType: _.toNumber(v.type),
						address: _.get(v, 'address', ''),
						language: _.get(v, 'language', '')
					};
				}),
				webAddresses: _.map(pharmacy.webAddresses, (v) => {
					return {
						webAddressId: v.id,
						webAddressType: _.toNumber(v.type),
						url: _.get(v, 'url', '')
					};
				})
			};

			// TODO: wrap in an edge call
			return this.$q.when(this.pharmacyV2Api
				.pharmacyUpsearchByTenantId({
					canInsert: true,
					canUpdate: true,
					skipSearch: false,
					model: request
				}).then((response) => {
					return new pme.Pharmacy(response.data.data);
				}));
        }

		search(pharmacy: pme.Pharmacy): angular.IPromise<pme.Pharmacy[]> {
			const request: DeepPartial<psgm.PharmacySearchModel> = {
				maxRecordCount: 20,
				pharmacyName: _.get(pharmacy, 'name', ''),
				npi: _.get(pharmacy, 'npi', ''),
				nabp: _.get(pharmacy, 'nabp', ''),
				city: _.get(pharmacy, 'addresses[0].city', ''),
				state: _.get(pharmacy, 'addresses[0].state', ''),
				zip: _.get(pharmacy, 'addresses[0].zip', ''),
				phoneNumber: _.get(pharmacy, 'phoneNumbers[0].number', ''),
				phoneType: _.get(pharmacy, 'phoneNumbers[0].type', 0)
			};

			// TODO: wrap in an edge call
			return this.$q.when(this.pharmacyV2Api.pharmacySearchByTenantId(request).then((response) => {
				const temp: pme.Pharmacy[] = [];

				for (const pharmacy of response.data.data.pharmacies) {
					temp.push(new pme.Pharmacy(pharmacy));
                }

				return temp;
            }));
        }
    }
}